import React from 'react';
import { Award, Headphones, Settings, Users } from 'lucide-react';

const benefits = [
  {
    title: 'Certified Infor M3 Expertise',
    description: '150+ M3 projects across global manufacturing and distribution environments.',
    backgroundColor: '#FFF1EE',
    borderColor: '#FFD7D0',
    iconBackground: '#FFE1DB',
    accentColor: '#D81820',
    icon: Award,
  },
  {
    title: 'Industry-Specific Domain Knowledge',
    description: 'Solutions shaped for manufacturing, distribution, fashion, food and beverage, and more.',
    backgroundColor: '#EEF6FF',
    borderColor: '#CFE3FF',
    iconBackground: '#DCEBFF',
    accentColor: '#2563EB',
    icon: Users,
  },
  {
    title: 'Proven M3 Implementation Methodology',
    description: 'Agile, accelerator-led delivery reduces project risk and speeds time-to-value.',
    backgroundColor: '#FFF8E8',
    borderColor: '#F7E3B2',
    iconBackground: '#FFEDC4',
    accentColor: '#B7791F',
    icon: Settings,
  },
  {
    title: 'End-to-End M3 Lifecycle Support',
    description: 'Ongoing support, monitoring, and improvement keep M3 performing after go-live.',
    backgroundColor: '#EFFBF3',
    borderColor: '#CDEED8',
    iconBackground: '#DDF5E5',
    accentColor: '#16803C',
    icon: Headphones,
  },
];

const WhyChooseCard = ({
  icon: Icon,
  title,
  description,
  backgroundColor,
  borderColor,
  iconBackground,
  accentColor,
}) => (
  <article
    className="group flex h-full min-w-0 flex-col rounded-2xl border p-6 transition duration-300 hover:-translate-y-1 hover:shadow-lg"
    style={{
      backgroundColor,
      borderColor,
      boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
    }}
  >
    <div
      className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl transition duration-300 group-hover:scale-105"
      style={{ backgroundColor: iconBackground, color: accentColor }}
    >
      <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.9} />
    </div>

    <h3
      className="mb-3 text-lg font-bold leading-snug"
      style={{ color: '#1A2634' }}
    >
      {title}
    </h3>

    <p
      className="mt-auto text-sm font-medium leading-6"
      style={{ color: '#334155', textAlign: 'left' }}
    >
      {description}
    </p>
  </article>
);

const WhyChooseUs = () => {
  return (
    <section
      aria-labelledby="m3-why-choose-title"
      className="px-4 py-14 sm:px-6 lg:px-8 lg:py-20"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="mx-auto w-full max-w-7xl">
        <h2
          id="m3-why-choose-title"
          className="mb-10 text-2xl font-bold tracking-tight sm:text-3xl md:text-4xl"
          style={{ color: '#1A2634' }}
        >
          Why Choose PT KCS for Infor M3?
        </h2>

        <div className="grid gap-5 sm:grid-cols-2">
          {benefits.map((benefit) => (
            <WhyChooseCard key={benefit.title} {...benefit} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
